module.exports = __webpack_public_path__ + "img/pc_tu.48881dec.png";